import { defineStore, acceptHMRUpdate } from "pinia";
import { ref } from "vue";
import type { WidgetLink } from "@modernary/mui/components/widgetGrid";

export const useInternalLandingStore = defineStore("internalLandingStore", () => {
  const solidWasteLinks = ref<WidgetLink[]>([]);
  const sustainabilityLinks = ref<WidgetLink[]>([]);

  function reset() {
    solidWasteLinks.value = [];
    sustainabilityLinks.value = [];
  }

  return {
    solidWasteLinks,
    sustainabilityLinks,
    reset,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useInternalLandingStore, import.meta.hot));
}
